import { LinearGradient } from 'expo-linear-gradient';
import { Platform, StyleSheet } from 'react-native';
import { colors } from '../../theme/colors';

interface BentoSurfaceProps {
  radius: number;
}

/**
 * The native rendering of the level-1 card fill. Web renders the same role as
 * "ultra-clear" glass — a white veil over a backdrop blur — which native
 * cannot do, so here the fill is a 160deg teal-ink gradient with a soft
 * top-right sheen, laid down with expo-linear-gradient.
 *
 * Drop it in as the first child of a card container, behind the content. On
 * web it renders nothing: `cardSurface()` already carries the fill, and a
 * gradient underneath would tint the glass back into a separate pane.
 */
export function BentoSurface({ radius }: Readonly<BentoSurfaceProps>) {
  if (Platform.OS === 'web') {
    return null;
  }

  return (
    <>
      <LinearGradient
        colors={colors.surface.bento.gradient}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
        style={[StyleSheet.absoluteFill, { borderRadius: radius }]}
        pointerEvents="none"
      />
      <LinearGradient
        colors={colors.surface.bento.gradientSheen}
        start={{ x: 1, y: 0 }}
        end={{ x: 0.35, y: 0.7 }}
        style={[StyleSheet.absoluteFill, { borderRadius: radius }]}
        pointerEvents="none"
      />
    </>
  );
}
